module.exports = __webpack_public_path__ + "static/media/double-park-2-1.eae1880a.jpg";